import React from "react";

/**
 * Encore Theatre & Gallery responsive wordmark.
 *
 * - Browser picks the small (325w / 36KB) or full (993w / 420KB) PNG via srcSet.
 * - Intrinsic width/height attributes prevent layout shift while loading.
 * - max-w-full keeps the mark from overflowing tiny viewports.
 * - object-contain preserves aspect ratio at any height.
 *
 * Sizes:
 *   nav     – top navigation bar (most compact)
 *   compact – admin header (very compact)
 *   card    – inside cards (e.g. admin login)
 *   hero    – footer / prominent contexts
 */
const SIZE_CLASSES = {
  nav: "h-9 sm:h-10 md:h-12 lg:h-14",
  compact: "h-8 sm:h-9 md:h-10",
  card: "h-12 sm:h-14 md:h-16",
  hero: "h-16 sm:h-20 md:h-24 lg:h-28",
};

export default function EncoreWordmark({ size = "nav", className = "", ...rest }) {
  const heightClasses = SIZE_CLASSES[size] || SIZE_CLASSES.nav;
  return (
    <img
      src="/brand/encore-wordmark.png"
      srcSet="/brand/encore-wordmark-sm.png 325w, /brand/encore-wordmark.png 993w"
      sizes="(max-width: 640px) 160px, (max-width: 1024px) 220px, 320px"
      alt="Encore Theatre and Gallery"
      width={993}
      height={293}
      draggable={false}
      className={`${heightClasses} w-auto max-w-full object-contain ${className}`}
      {...rest}
    />
  );
}
